import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Check } from "@phosphor-icons/react";
import HeroWidget from "@/components/site/HeroWidget";

const DURATIONS = { standard: 3200, direct: 3400, connect: 3200, amount: 4800, processed: 3200 };
const ORDER = ["standard", "direct", "connect", "amount", "processed"];

const STEPS = [
  {
    id: "standard",
    num: "01",
    title: "Standard deposit",
    desc: "Copy the address and leave the app.",
  },
  {
    id: "direct",
    num: "02",
    title: "Direct deposit",
    desc: "One tap, powered by OpenDeposit.",
  },
  {
    id: "connect",
    num: "03",
    title: "Connect wallet",
    desc: "No addresses, no app switching.",
  },
  {
    id: "amount",
    num: "04",
    title: "Add amount",
    desc: "Authorize from your wallet.",
  },
  {
    id: "processed",
    num: "05",
    title: "Deposit processed",
    desc: "Funds land on-chain in seconds.",
  },
];

export default function HeroFlow() {
  const [phase, setPhase] = useState("standard");

  useEffect(() => {
    const t = setTimeout(() => {
      setPhase((p) => ORDER[(ORDER.indexOf(p) + 1) % ORDER.length]);
    }, DURATIONS[phase]);
    return () => clearTimeout(t);
  }, [phase]);

  const activeIdx = ORDER.indexOf(phase);

  return (
    <div className="grid grid-cols-1 md:grid-cols-[minmax(200px,220px)_1fr] gap-4 items-start">
      <div className="hidden md:flex flex-col gap-1.5" data-testid="widget-steps">
        {STEPS.map((s, i) => {
          const done = i < activeIdx;
          const active = i === activeIdx;
          const header =
            i === 0 ? "Today" : i === 2 ? "With OpenDeposit" : null;
          return (
            <div key={s.id} className="contents">
              {header && (
                <p
                  className={`px-1 text-[10px] font-bold uppercase tracking-[0.18em] ${
                    i === 0 ? "text-zinc-400" : "text-[#0a0a0a]"
                  } ${i === 2 ? "mt-3" : ""}`}
                >
                  {header}
                </p>
              )}
              <button
                type="button"
                onClick={() => setPhase(s.id)}
                data-testid={`widget-step-${i + 1}`}
                className={`group relative overflow-hidden flex items-start gap-3 rounded-2xl border px-3.5 py-2.5 text-left transition-all ${
                  active
                    ? "border-[#f5d949] bg-white shadow-sm"
                    : done
                      ? "border-black/10 bg-white/70"
                      : "border-black/10 bg-white/50 hover:bg-white"
                }`}
              >
                <span
                  className={`grid h-7 w-7 shrink-0 place-items-center rounded-full text-[11px] font-bold transition-colors ${
                    active
                      ? "bg-[#f5d949] text-black"
                      : done
                        ? "bg-[#0a0a0a] text-white"
                        : "bg-zinc-100 text-zinc-500"
                  }`}
                >
                  {done ? <Check size={13} weight="bold" /> : s.num}
                </span>
                <div className="min-w-0">
                  <p className="text-sm font-bold leading-tight text-[#0a0a0a]">
                    {s.title}
                  </p>
                  <p className="text-[11px] text-zinc-500 leading-snug mt-0.5 truncate">
                    {s.desc}
                  </p>
                </div>
                {active && (
                  <span className="absolute left-0 bottom-0 h-[3px] w-full overflow-hidden">
                    <motion.span
                      key={phase}
                      initial={{ width: 0 }}
                      animate={{ width: "100%" }}
                      transition={{
                        duration: DURATIONS[phase] / 1000,
                        ease: "linear",
                      }}
                      className="block h-full bg-[#f5d949]"
                    />
                  </span>
                )}
              </button>
            </div>
          );
        })}
      </div>

      <HeroWidget phase={phase} />
    </div>
  );
}